import React from "react";

const PillContainer = ({
  mainText = "88% HIGHER RESPONSE RATE",
  subText = "THAN WITHOUT QUIS",
  gradient = "from-[#5B7CFA] to-[#F96DB6]",
  size = "sm", 
}) => {
  const pillClass = size === 'sm'
    ? 'px-3 py-1.5 rounded-full bg-gradient-to-r text-xs min-w-[120px]'
    : 'px-6 py-3 rounded-full bg-gradient-to-r text-lg min-w-[260px]';
  const textClass = size === 'sm' ? 'text-xs font-bold text-center text-white' : 'text-lg font-bold text-center text-white';
  const subTextClass = size === 'sm' ? 'text-black font-semibold text-[10px] mt-1' : 'text-black font-semibold text-base mt-2';
  return (
    <div className="flex flex-col items-center">
      <div
        className={`${pillClass} ${gradient} flex items-center justify-center`}
      >
        <span className={textClass}>{mainText}</span>
      </div>
      <span className={subTextClass}>{subText}</span>
    </div>
  );
};

export default PillContainer; 